/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { AccessEffects } from './access.effect';
import { HeaderNotificationsEffects } from './header-notifications.effect';
import { PurchaseEffects } from './purchase.effect';
import { SignupEffects } from './signup.effect';
import { SportsEffects } from './sports.effect';
import { UserDataEffects } from './user-data.effect';
import { UserInvitesEffects } from './user-invites.effect';
import { UserNewVideosEffects } from './user-new-videos.effect';

export const effects: any[] = [
  AccessEffects,
  HeaderNotificationsEffects,
  PurchaseEffects,
  SignupEffects,
  SportsEffects,
  UserDataEffects,
  UserInvitesEffects,
  UserNewVideosEffects,
];

export * from './access.effect';
export * from './header-notifications.effect';
export * from './purchase.effect';
export * from './signup.effect';
export * from './sports.effect';
export * from './user-data.effect';
export * from './user-invites.effect';
export * from './user-new-videos.effect';
